import main from './main';

const rootReducer = {
  main,
};

export default rootReducer;
